import { useState } from "react";
import Title from "../../components/common/title/Title";
import { getApi, postApi } from "../../services/api/globalApi";

export default function ProductPriceImport() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [result, setResult] = useState(null);

  const downloadTemplate = async () => {
    try {
      setMessage("");
      const response = await getApi({ path: "admin/products/prices/template", responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = "product_prices_template.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      setMessage("دانلود فایل نمونه انجام نشد.");
    }
  };

  const upload = async (event) => {
    event.preventDefault();
    if (!file || loading) return;
    if (!file.name.toLowerCase().endsWith(".xlsx") || file.size > 5 * 1024 * 1024) {
      setMessage("فایل xlsx با حجم حداکثر ۵ مگابایت انتخاب کنید.");
      setResult(null);
      return;
    }
    setLoading(true);
    setMessage("");
    setResult(null);
    try {
      const body = new FormData();
      body.append("file", file);
      const response = await postApi({
        path: "admin/products/prices/import",
        body,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(response.data.result);
    } catch (error) {
      setMessage(error?.response?.data?.message || "بارگذاری فایل انجام نشد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 space-y-5">
      <Title title="به‌روزرسانی قیمت محصولات با اکسل" />
      <p className="text-sm text-gray-600 dark:text-gray-300">
        ستون‌های فایل نمونه را با نام انگلیسی نگه دارید. SKU ورییشن را در ردیف جداگانه وارد کنید و برای آن isVar را true بگذارید؛ برای محصول ساده false بگذارید. خانهٔ قیمت خالی تغییر نمی‌کند. عددهایی مانند 240'000 پذیرفته می‌شوند.
      </p>
      <button type="button" onClick={downloadTemplate} className="px-4 py-2 rounded-lg bg-slate-100 text-slate-800">
        دانلود فایل نمونه اکسل
      </button>
      <form onSubmit={upload} className="flex flex-wrap items-center gap-3">
        <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(event) => { setFile(event.target.files?.[0] || null); setResult(null); setMessage(""); }} />
        <button type="submit" disabled={!file || loading} className="px-4 py-2 rounded-lg bg-green-600 text-white disabled:opacity-50">
          {loading ? "در حال بارگذاری..." : "بارگذاری و به‌روزرسانی قیمت"}
        </button>
      </form>
      {message && <p role="alert" className="text-red-600">{message}</p>}
      {result && (
        <div className="space-y-4">
          <p className="text-sm dark:text-white">
            کل ردیف‌ها: {result.totalRows} | به‌روزرسانی شده: {result.updatedRows} | بدون قیمت جدید: {result.skippedRows} | ردیف‌های خطادار: {result.errorRows}
          </p>
          {result.errors?.length > 0 && (
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-right border-collapse">
                <thead><tr className="bg-gray-100 dark:bg-gray-800 dark:text-white">
                  <th className="p-2">ردیف اکسل</th><th className="p-2">SKU</th><th className="p-2">نام محصول</th><th className="p-2">شناسه محصول</th><th className="p-2">دلیل خطا</th>
                </tr></thead>
                <tbody>{result.errors.map((item, index) => (
                  <tr key={`${item.rowNumber}-${index}`} className="border-b dark:text-white">
                    <td className="p-2">{item.rowNumber}</td><td className="p-2" dir="ltr">{item.sku || "—"}</td>
                    <td className="p-2">{item.productName || "—"}</td><td className="p-2" dir="ltr">{item.productId || "—"}</td>
                    <td className="p-2 text-red-600">{item.reason}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
